// import { useState, useEffect } from "react";
// import {
//   Plus,
//   Scale,
//   CheckCircle,
//   XCircle,
//   Search,
//   Trash2,
// } from "lucide-react";
// import Modal from "../../components/ui/Modal";
// import { productAPI, weightAPI } from "../../services/api";

// const getImageUrl = (imagePath) => {
//   if (!imagePath) return "https://via.placeholder.com/150";
//   if (
//     imagePath.startsWith("http://") ||
//     imagePath.startsWith("https://") ||
//     imagePath.startsWith("blob:")
//   ) {
//     return imagePath;
//   }
//   const apiUrl =
//     process.env.REACT_APP_API_URL || "http://localhost:5000/backend";
//   const serverOrigin = apiUrl.replace(/\/backend\/?$/, "");
//   const cleanPath = imagePath.startsWith("/") ? imagePath : `/${imagePath}`;

//   const finalPath = cleanPath.startsWith("/uploads/")
//     ? `/backend${cleanPath}`
//     : cleanPath;

//   return `${serverOrigin}${finalPath}`;
// };

// export default function CompanyForms() {
//   const [entries, setEntries] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [modal, setModal] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [filter, setFilter] = useState("All");
//   const [deletingId, setDeletingId] = useState(null);
//   const [form, setForm] = useState({ product_id: "", weight: "" });
//   const [page, setPage] = useState(1);
//   const [total, setTotal] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [search, setSearch] = useState("");
//   const [debouncedSearch, setDebouncedSearch] = useState("");

//   useEffect(() => {
//     const t = setTimeout(() => {
//       setDebouncedSearch(search);
//       setPage(1);
//     }, 300);
//     return () => clearTimeout(t);
//   }, [search]);

//   const load = () => {
//     setLoading(true);
//     Promise.all([
//       weightAPI.list({
//         limit: pageSize,
//         offset: (page - 1) * pageSize,
//         ...(filter !== "All" && { result: filter }),
//         ...(debouncedSearch.trim() && { search: debouncedSearch.trim() }),
//       }),
//       productAPI.list(),
//     ])
//       .then(([w, p]) => {
//         setEntries(w.data.entries);
//         setTotal(w.data.total || 0);
//         setProducts(p.data);
//       })
//       .finally(() => setLoading(false));
//   };
//   useEffect(() => {
//     load();
//   }, [page, pageSize, filter, debouncedSearch]);

//   const handlePageSizeChange = (e) => {
//     setPageSize(Number(e.target.value));
//     setPage(1);
//   };

//   const selected = products.find((p) => p.id === form.product_id);
//   const liveResult =
//     selected && form.weight
//       ? +form.weight >= selected.min_weight &&
//         +form.weight <= selected.max_weight
//         ? "Pass"
//         : "Fail"
//       : null;

//   const submit = async () => {
//     if (!form.product_id || !form.weight) return;
//     setSaving(true);
//     try {
//       await weightAPI.create({
//         product_id: form.product_id,
//         weight: +form.weight,
//       });
//       setForm({ product_id: "", weight: "" });
//       setModal(false);
//       load();
//     } catch (e) {
//       alert(e.message);
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Do you want to permanently delete this failed entry?"))
//       return;
//     setDeletingId(id);
//     try {
//       await weightAPI.delete(id);
//       load();
//     } catch (e) {
//       alert(e.message || "Delete failed");
//     } finally {
//       setDeletingId(null);
//     }
//   };

//   // Backend नेच filter (result=Pass/Fail) apply करून, योग्य pagination सहित
//   // entries पाठवलेल्या असतात — इथे परत client-side filter करायची गरज नाही.
//   // Actions column फक्त तेव्हाच दाखवायचा जेव्हा current page वर किमान एक Fail entry असेल
//   const hasFailEntries = entries.some((e) => e.result === "Fail");

//   return (
//     <div style={{ padding: 28 }}>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "flex-start",
//           marginBottom: 24,
//         }}
//       >
//         <div>
//           <h1 style={{ fontSize: 20, fontWeight: 700 }}>Weight History</h1>
//           <p style={{ color: "var(--text2)", fontSize: 13, marginTop: 2 }}>
//             Record and review weight check entries
//           </p>
//         </div>
//       </div>

//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           flexWrap: "wrap",
//           gap: 12,
//           marginBottom: 18,
//         }}
//       >
//         <div style={{ display: "flex", gap: 8 }}>
//           {["All", "Pass", "Fail"].map((f) => (
//             <button
//               key={f}
//               onClick={() => {
//                 setFilter(f);
//                 setPage(1);
//               }}
//               style={{
//                 padding: "6px 16px",
//                 borderRadius: 20,
//                 fontSize: 12,
//                 fontWeight: 600,
//                 background: filter === f ? "var(--accent)" : "var(--surface2)",
//                 color: filter === f ? "#0D0F14" : "var(--text2)",
//                 border:
//                   "1px solid " +
//                   (filter === f ? "var(--accent)" : "var(--border2)"),
//               }}
//             >
//               {f}
//             </button>
//           ))}
//         </div>

//         <div style={{ position: "relative", flex: "1 1 260px", maxWidth: 340 }}>
//           <Search
//             size={14}
//             color="var(--text3)"
//             style={{
//               position: "absolute",
//               left: 10,
//               top: "50%",
//               transform: "translateY(-50%)",
//             }}
//           />
//           <input
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder="Search by Part ID, Name, Serial No..."
//             style={{
//               width: "100%",
//               padding: "8px 12px 8px 32px",
//               borderRadius: 20,
//               background: "var(--surface2)",
//               border: "1px solid var(--border2)",
//               color: "var(--text)",
//               fontSize: 12.5,
//               outline: "none",
//             }}
//           />
//         </div>
//       </div>

//       <div className="card" style={{ padding: 0, overflow: "hidden" }}>
//         {loading ? (
//           <div
//             style={{ padding: 24, textAlign: "center", color: "var(--text2)" }}
//           >
//             Loading...
//           </div>
//         ) : (
//           <table>
//             <thead>
//               <tr>
//                 <th>Part ID</th>
//                 <th>Part</th>
//                 <th>Weight</th>
//                 <th>Range</th>
//                 <th>Image</th>
//                 <th>Result</th>
//                 <th>Serial Number</th>
//                 <th>Date</th>
//                 <th>Time</th>
//                 {hasFailEntries && <th>Actions</th>}
//               </tr>
//             </thead>
//             <tbody>
//               {entries.map((l) => (
//                 <tr key={l.id}>
//                   <td>
//                     <div
//                       style={{
//                         fontSize: 11,
//                         color: "var(--text3)",
//                         fontFamily: "var(--mono)",
//                         marginLeft: 14,
//                       }}
//                     >
//                       {l.product_code}
//                     </div>
//                   </td>

//                   <td>
//                     <div style={{ fontWeight: 500 }}>{l.product_name}</div>
//                   </td>

//                   <td>
//                     <span
//                       style={{
//                         fontFamily: "var(--mono)",
//                         fontSize: 14,
//                         fontWeight: 600,
//                         color:
//                           l.result === "Pass"
//                             ? "var(--success)"
//                             : "var(--danger)",
//                       }}
//                     >
//                       {l.weight}g
//                     </span>
//                   </td>
//                   <td
//                     style={{ fontFamily: "var(--mono)", color: "var(--text3)" }}
//                   >
//                     {l.min_weight}–{l.max_weight}g
//                   </td>
//                   <td>
//                     <img
//                       src={getImageUrl(l.product_image)}
//                       alt="Part"
//                       style={{
//                         width: 50,
//                         height: 50,
//                         borderRadius: 6,
//                         objectFit: "cover",
//                       }}
//                     />
//                   </td>
//                   <td>
//                     <span
//                       className={`badge ${l.result === "Pass" ? "badge-success" : "badge-danger"}`}
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 4,
//                         width: "fit-content",
//                       }}
//                     >
//                       {l.result === "Pass" ? (
//                         <CheckCircle size={10} />
//                       ) : (
//                         <XCircle size={10} />
//                       )}{" "}
//                       {l.result}
//                     </span>
//                   </td>
//                   <td className="text2 mono">{l.serial_number || "—"}</td>
//                   <td className="text2">
//                     {new Date(l.recorded_at).toLocaleDateString()}
//                   </td>
//                   <td className="text3">
//                     {new Date(l.recorded_at)
//                       .toLocaleTimeString([], {
//                         hour: "2-digit",
//                         minute: "2-digit",
//                         hour12: true,
//                       })
//                       .replace(/\s*[APap][Mm]/g, "")}
//                   </td>
//                   {hasFailEntries && (
//                     <td>
//                       {l.result === "Fail" && (
//                         <button
//                           onClick={() => handleDelete(l.id)}
//                           disabled={deletingId === l.id}
//                           title="Delete this Fail entry"
//                           style={{
//                             background: "rgba(255,77,106,0.1)",
//                             border: "1px solid var(--danger)",
//                             borderRadius: 6,
//                             padding: "5px 8px",
//                             cursor:
//                               deletingId === l.id ? "not-allowed" : "pointer",
//                             color: "var(--danger)",
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 4,
//                             fontSize: 11,
//                             fontWeight: 600,
//                             opacity: deletingId === l.id ? 0.5 : 1,
//                           }}
//                         >
//                           <Trash2 size={12} />
//                           {deletingId === l.id ? "..." : "Delete"}
//                         </button>
//                       )}
//                     </td>
//                   )}
//                 </tr>
//               ))}
//               {entries.length === 0 && (
//                 <tr>
//                   <td
//                     colSpan={hasFailEntries ? 10 : 9}
//                     style={{
//                       textAlign: "center",
//                       color: "var(--text3)",
//                       padding: 20,
//                     }}
//                   >
//                     No entries found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         )}
//       </div>

//       <div
//         style={{
//           display: "flex",
//           justifyContent: "flex-end",
//           alignItems: "center",
//           gap: 12,
//           marginTop: 14,
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 6,
//             fontSize: 12,
//             color: "var(--text3)",
//           }}
//         >
//           <h6>Rows per page:</h6>
//           <select
//             value={pageSize}
//             onChange={handlePageSizeChange}
//             style={{
//               padding: "4px 8px",
//               borderRadius: 6,
//               background: "var(--surface2)",
//               border: "1px solid var(--border2)",
//               color: "var(--text)",
//               fontSize: 12,
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//             <option value={100}>100</option>
//           </select>
//         </div>

//         {total > 0 && (
//           <>
//             <span style={{ fontSize: 12, color: "var(--text3)" }}>
//               {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} of{" "}
//               {total}
//             </span>
//             <button
//               className="btn-secondary"
//               disabled={page === 1}
//               onClick={() => setPage((p) => Math.max(1, p - 1))}
//               style={{ opacity: page === 1 ? 0.5 : 1 }}
//             >
//               Prev
//             </button>
//             <button
//               className="btn-secondary"
//               disabled={page * pageSize >= total}
//               onClick={() => setPage((p) => p + 1)}
//               style={{ opacity: page * pageSize >= total ? 0.5 : 1 }}
//             >
//               Next
//             </button>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

// import { useState, useEffect } from "react";
// import {
//   Plus,
//   Scale,
//   CheckCircle,
//   XCircle,
//   Search,
//   Trash2,
// } from "lucide-react";
// import Modal from "../../components/ui/Modal";
// import { productAPI, weightAPI } from "../../services/api";

// const getImageUrl = (imagePath) => {
//   if (!imagePath) return "https://via.placeholder.com/150";
//   if (
//     imagePath.startsWith("http://") ||
//     imagePath.startsWith("https://") ||
//     imagePath.startsWith("blob:")
//   ) {
//     return imagePath;
//   }
//   const apiUrl =
//     process.env.REACT_APP_API_URL || "http://localhost:5000/backend";
//   const serverOrigin = apiUrl.replace(/\/backend\/?$/, "");
//   const cleanPath = imagePath.startsWith("/") ? imagePath : `/${imagePath}`;

//   const finalPath = cleanPath.startsWith("/uploads/")
//     ? `/backend${cleanPath}`
//     : cleanPath;

//   return `${serverOrigin}${finalPath}`;
// };

// export default function CompanyForms() {
//   const [entries, setEntries] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [modal, setModal] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [filter, setFilter] = useState("All");
//   const [deletingId, setDeletingId] = useState(null);
//   const [form, setForm] = useState({ product_id: "", weight: "" });
//   const [page, setPage] = useState(1);
//   const [total, setTotal] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [search, setSearch] = useState("");
//   const [debouncedSearch, setDebouncedSearch] = useState("");

//   useEffect(() => {
//     const t = setTimeout(() => {
//       setDebouncedSearch(search);
//       setPage(1);
//     }, 300);
//     return () => clearTimeout(t);
//   }, [search]);

//   const load = () => {
//     setLoading(true);
//     Promise.all([
//       weightAPI.list({
//         limit: pageSize,
//         offset: (page - 1) * pageSize,
//         ...(filter !== "All" && { result: filter }),
//         ...(debouncedSearch.trim() && { search: debouncedSearch.trim() }),
//       }),
//       productAPI.list(),
//     ])
//       .then(([w, p]) => {
//         setEntries(w.data.entries);
//         setTotal(w.data.total || 0);
//         setProducts(p.data);
//       })
//       .finally(() => setLoading(false));
//   };
//   useEffect(() => {
//     load();
//   }, [page, pageSize, filter, debouncedSearch]);

//   const handlePageSizeChange = (e) => {
//     setPageSize(Number(e.target.value));
//     setPage(1);
//   };

//   const selected = products.find((p) => p.id === form.product_id);
//   const liveResult =
//     selected && form.weight
//       ? +form.weight >= selected.min_weight &&
//         +form.weight <= selected.max_weight
//         ? "Pass"
//         : "Fail"
//       : null;

//   const submit = async () => {
//     if (!form.product_id || !form.weight) return;
//     setSaving(true);
//     try {
//       await weightAPI.create({
//         product_id: form.product_id,
//         weight: +form.weight,
//       });
//       setForm({ product_id: "", weight: "" });
//       setModal(false);
//       load();
//     } catch (e) {
//       alert(e.message);
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Do you want to permanently delete this failed entry?"))
//       return;
//     setDeletingId(id);
//     try {
//       await weightAPI.delete(id);
//       load();
//     } catch (e) {
//       alert(e.message || "Delete failed");
//     } finally {
//       setDeletingId(null);
//     }
//   };

//   // Backend नेच filter (result=Pass/Fail) apply करून, योग्य pagination सहित
//   // entries पाठवलेल्या असतात — इथे परत client-side filter करायची गरज नाही.
//   // Actions column फक्त तेव्हाच दाखवायचा जेव्हा current page वर किमान एक Fail entry असेल
//   const hasFailEntries = entries.some((e) => e.result === "Fail");

//   return (
//     <div style={{ padding: 28 }}>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "flex-start",
//           marginBottom: 24,
//         }}
//       >
//         <div>
//           <h1 style={{ fontSize: 20, fontWeight: 700 }}>Weight History</h1>
//           <p style={{ color: "var(--text2)", fontSize: 13, marginTop: 2 }}>
//             Record and review weight check entries
//           </p>
//         </div>
//       </div>

//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           flexWrap: "wrap",
//           gap: 12,
//           marginBottom: 18,
//         }}
//       >
//         <div style={{ display: "flex", gap: 8 }}>
//           {["All", "Pass", "Fail"].map((f) => (
//             <button
//               key={f}
//               onClick={() => {
//                 setFilter(f);
//                 setPage(1);
//               }}
//               style={{
//                 padding: "6px 16px",
//                 borderRadius: 20,
//                 fontSize: 12,
//                 fontWeight: 600,
//                 background: filter === f ? "var(--accent)" : "var(--surface2)",
//                 color: filter === f ? "#0D0F14" : "var(--text2)",
//                 border:
//                   "1px solid " +
//                   (filter === f ? "var(--accent)" : "var(--border2)"),
//               }}
//             >
//               {f}
//             </button>
//           ))}
//         </div>

//         <div style={{ position: "relative", flex: "1 1 260px", maxWidth: 340 }}>
//           <Search
//             size={14}
//             color="var(--text3)"
//             style={{
//               position: "absolute",
//               left: 10,
//               top: "50%",
//               transform: "translateY(-50%)",
//             }}
//           />
//           <input
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder="Search by Part ID, Name, Serial No..."
//             style={{
//               width: "100%",
//               padding: "8px 12px 8px 32px",
//               borderRadius: 20,
//               background: "var(--surface2)",
//               border: "1px solid var(--border2)",
//               color: "var(--text)",
//               fontSize: 12.5,
//               outline: "none",
//             }}
//           />
//         </div>
//       </div>

//       <div className="card" style={{ padding: 0, overflow: "hidden" }}>
//         {loading ? (
//           <div
//             style={{ padding: 24, textAlign: "center", color: "var(--text2)" }}
//           >
//             Loading...
//           </div>
//         ) : (
//           <table>
//             <thead>
//               <tr>
//                 <th>Part ID</th>
//                 <th>Part</th>
//                 <th>Weight</th>
//                 <th>Range</th>
//                 <th>Image</th>
//                 <th>Result</th>
//                 <th>Serial Number</th>
//                 <th>Date</th>
//                 <th>Time</th>
//                 {hasFailEntries && <th>Actions</th>}
//               </tr>
//             </thead>
//             <tbody>
//               {entries.map((l) => (
//                 <tr key={l.id}>
//                   <td>
//                     <div
//                       style={{
//                         fontSize: 11,
//                         color: "var(--text3)",
//                         fontFamily: "var(--mono)",
//                         marginLeft: 14,
//                       }}
//                     >
//                       {l.product_code}
//                     </div>
//                   </td>

//                   <td>
//                     <div style={{ fontWeight: 500 }}>{l.product_name}</div>
//                   </td>

//                   <td>
//                     <span
//                       style={{
//                         fontFamily: "var(--mono)",
//                         fontSize: 14,
//                         fontWeight: 600,
//                         color:
//                           l.result === "Pass"
//                             ? "var(--success)"
//                             : "var(--danger)",
//                       }}
//                     >
//                       {l.weight}g
//                     </span>
//                   </td>
//                   <td
//                     style={{ fontFamily: "var(--mono)", color: "var(--text3)" }}
//                   >
//                     {l.min_weight}–{l.max_weight}g
//                   </td>
//                   <td>
//                     <img
//                       src={getImageUrl(l.product_image)}
//                       alt="Part"
//                       style={{
//                         width: 50,
//                         height: 50,
//                         borderRadius: 6,
//                         objectFit: "cover",
//                       }}
//                     />
//                   </td>
//                   <td>
//                     <span
//                       className={`badge ${l.result === "Pass" ? "badge-success" : "badge-danger"}`}
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 4,
//                         width: "fit-content",
//                       }}
//                     >
//                       {l.result === "Pass" ? (
//                         <CheckCircle size={10} />
//                       ) : (
//                         <XCircle size={10} />
//                       )}{" "}
//                       {l.result}
//                     </span>
//                   </td>
//                   <td className="text2 mono">{l.serial_number || "—"}</td>
//                   <td className="text2">
//                     {new Date(l.recorded_at).toLocaleDateString()}
//                   </td>
//                   <td className="text3">
//                     {new Date(l.recorded_at)
//                       .toLocaleTimeString([], {
//                         hour: "2-digit",
//                         minute: "2-digit",
//                         hour12: true,
//                       })
//                       .replace(/\s*[APap][Mm]/g, "")}
//                   </td>
//                   {hasFailEntries && (
//                     <td>
//                       {l.result === "Fail" && (
//                         <button
//                           onClick={() => handleDelete(l.id)}
//                           disabled={deletingId === l.id}
//                           title="Delete this Fail entry"
//                           style={{
//                             background: "rgba(255,77,106,0.1)",
//                             border: "1px solid var(--danger)",
//                             borderRadius: 6,
//                             padding: "5px 8px",
//                             cursor:
//                               deletingId === l.id ? "not-allowed" : "pointer",
//                             color: "var(--danger)",
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 4,
//                             fontSize: 11,
//                             fontWeight: 600,
//                             opacity: deletingId === l.id ? 0.5 : 1,
//                           }}
//                         >
//                           <Trash2 size={12} />
//                           {deletingId === l.id ? "..." : "Delete"}
//                         </button>
//                       )}
//                     </td>
//                   )}
//                 </tr>
//               ))}
//               {entries.length === 0 && (
//                 <tr>
//                   <td
//                     colSpan={hasFailEntries ? 10 : 9}
//                     style={{
//                       textAlign: "center",
//                       color: "var(--text3)",
//                       padding: 20,
//                     }}
//                   >
//                     No entries found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         )}
//       </div>

//       <div
//         style={{
//           display: "flex",
//           justifyContent: "flex-end",
//           alignItems: "center",
//           gap: 12,
//           marginTop: 14,
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 6,
//             fontSize: 12,
//             color: "var(--text3)",
//           }}
//         >
//           <h6>Rows per page:</h6>
//           <select
//             value={pageSize}
//             onChange={handlePageSizeChange}
//             style={{
//               padding: "4px 8px",
//               borderRadius: 6,
//               background: "var(--surface2)",
//               border: "1px solid var(--border2)",
//               color: "var(--text)",
//               fontSize: 12,
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//             <option value={100}>100</option>
//           </select>
//         </div>

//         {total > 0 && (
//           <>
//             <span style={{ fontSize: 12, color: "var(--text3)" }}>
//               {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} of{" "}
//               {total}
//             </span>
//             <button
//               className="btn-secondary"
//               disabled={page === 1}
//               onClick={() => setPage((p) => Math.max(1, p - 1))}
//               style={{ opacity: page === 1 ? 0.5 : 1 }}
//             >
//               Prev
//             </button>
//             <button
//               className="btn-secondary"
//               disabled={page * pageSize >= total}
//               onClick={() => setPage((p) => p + 1)}
//               style={{ opacity: page * pageSize >= total ? 0.5 : 1 }}
//             >
//               Next
//             </button>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

// import { useState, useEffect } from "react";
// import {
//   Plus,
//   Scale,
//   CheckCircle,
//   XCircle,
//   Search,
//   Trash2,
// } from "lucide-react";
// import Modal from "../../components/ui/Modal";
// import { productAPI, weightAPI } from "../../services/api";

// const getImageUrl = (imagePath) => {
//   if (!imagePath) return "https://via.placeholder.com/150";
//   if (
//     imagePath.startsWith("http://") ||
//     imagePath.startsWith("https://") ||
//     imagePath.startsWith("blob:")
//   ) {
//     return imagePath;
//   }
//   const apiUrl =
//     process.env.REACT_APP_API_URL || "http://localhost:5000/backend";
//   const serverOrigin = apiUrl.replace(/\/backend\/?$/, "");
//   const cleanPath = imagePath.startsWith("/") ? imagePath : `/${imagePath}`;

//   const finalPath = cleanPath.startsWith("/uploads/")
//     ? `/backend${cleanPath}`
//     : cleanPath;

//   return `${serverOrigin}${finalPath}`;
// };

// export default function CompanyForms() {
//   const [entries, setEntries] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [modal, setModal] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [filter, setFilter] = useState("All");
//   const [deletingId, setDeletingId] = useState(null);
//   const [form, setForm] = useState({ product_id: "", weight: "" });
//   const [page, setPage] = useState(1);
//   const [total, setTotal] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [search, setSearch] = useState("");
//   const [debouncedSearch, setDebouncedSearch] = useState("");

//   useEffect(() => {
//     const t = setTimeout(() => {
//       setDebouncedSearch(search);
//       setPage(1);
//     }, 300);
//     return () => clearTimeout(t);
//   }, [search]);

//   const load = () => {
//     setLoading(true);
//     Promise.all([
//       weightAPI.list({
//         limit: pageSize,
//         offset: (page - 1) * pageSize,
//         ...(filter !== "All" && { result: filter }),
//         ...(debouncedSearch.trim() && { search: debouncedSearch.trim() }),
//       }),
//       productAPI.list(),
//     ])
//       .then(([w, p]) => {
//         setEntries(w.data.entries);
//         setTotal(w.data.total || 0);
//         setProducts(p.data);
//       })
//       .finally(() => setLoading(false));
//   };
//   useEffect(() => {
//     load();
//   }, [page, pageSize, filter, debouncedSearch]);

//   const handlePageSizeChange = (e) => {
//     setPageSize(Number(e.target.value));
//     setPage(1);
//   };

//   const selected = products.find((p) => p.id === form.product_id);
//   const liveResult =
//     selected && form.weight
//       ? +form.weight >= selected.min_weight &&
//         +form.weight <= selected.max_weight
//         ? "Pass"
//         : "Fail"
//       : null;

//   const submit = async () => {
//     if (!form.product_id || !form.weight) return;
//     setSaving(true);
//     try {
//       await weightAPI.create({
//         product_id: form.product_id,
//         weight: +form.weight,
//       });
//       setForm({ product_id: "", weight: "" });
//       setModal(false);
//       load();
//     } catch (e) {
//       alert(e.message);
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Do you want to permanently delete this failed entry?"))
//       return;
//     setDeletingId(id);
//     try {
//       await weightAPI.delete(id);
//       load();
//     } catch (e) {
//       alert(e.message || "Delete failed");
//     } finally {
//       setDeletingId(null);
//     }
//   };

//   // Backend नेच filter (result=Pass/Fail) apply करून, योग्य pagination सहित
//   // entries पाठवलेल्या असतात — इथे परत client-side filter करायची गरज नाही.
//   // Actions column फक्त तेव्हाच दाखवायचा जेव्हा current page वर किमान एक Fail entry असेल
//   const hasFailEntries = entries.some((e) => e.result === "Fail");

//   return (
//     <div style={{ padding: 28 }}>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "flex-start",
//           marginBottom: 24,
//         }}
//       >
//         <div>
//           <h1 style={{ fontSize: 20, fontWeight: 700 }}>Weight History</h1>
//           <p style={{ color: "var(--text2)", fontSize: 13, marginTop: 2 }}>
//             Record and review weight check entries
//           </p>
//         </div>
//       </div>

//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           flexWrap: "wrap",
//           gap: 12,
//           marginBottom: 18,
//         }}
//       >
//         <div style={{ display: "flex", gap: 8 }}>
//           {["All", "Pass", "Fail"].map((f) => (
//             <button
//               key={f}
//               onClick={() => {
//                 setFilter(f);
//                 setPage(1);
//               }}
//               style={{
//                 padding: "6px 16px",
//                 borderRadius: 20,
//                 fontSize: 12,
//                 fontWeight: 600,
//                 background: filter === f ? "var(--accent)" : "var(--surface2)",
//                 color: filter === f ? "#0D0F14" : "var(--text2)",
//                 border:
//                   "1px solid " +
//                   (filter === f ? "var(--accent)" : "var(--border2)"),
//               }}
//             >
//               {f}
//             </button>
//           ))}
//         </div>

//         <div style={{ position: "relative", flex: "1 1 260px", maxWidth: 340 }}>
//           <Search
//             size={14}
//             color="var(--text3)"
//             style={{
//               position: "absolute",
//               left: 10,
//               top: "50%",
//               transform: "translateY(-50%)",
//             }}
//           />
//           <input
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder="Search by Part ID, Name, Serial No..."
//             style={{
//               width: "100%",
//               padding: "8px 12px 8px 32px",
//               borderRadius: 20,
//               background: "var(--surface2)",
//               border: "1px solid var(--border2)",
//               color: "var(--text)",
//               fontSize: 12.5,
//               outline: "none",
//             }}
//           />
//         </div>
//       </div>

//       <div className="card" style={{ padding: 0, overflow: "hidden" }}>
//         {loading ? (
//           <div
//             style={{ padding: 24, textAlign: "center", color: "var(--text2)" }}
//           >
//             Loading...
//           </div>
//         ) : (
//           <table>
//             <thead>
//               <tr>
//                 <th>Part ID</th>
//                 <th>Part</th>
//                 <th>Weight</th>
//                 <th>Range</th>
//                 <th>Image</th>
//                 <th>Result</th>
//                 <th>Serial Number</th>
//                 <th>Date</th>
//                 <th>Time</th>
//                 {hasFailEntries && <th>Actions</th>}
//               </tr>
//             </thead>
//             <tbody>
//               {entries.map((l) => (
//                 <tr key={l.id}>
//                   <td>
//                     <div
//                       style={{
//                         fontSize: 11,
//                         color: "var(--text3)",
//                         fontFamily: "var(--mono)",
//                         marginLeft: 14,
//                       }}
//                     >
//                       {l.product_code}
//                     </div>
//                   </td>

//                   <td>
//                     <div style={{ fontWeight: 500 }}>{l.product_name}</div>
//                   </td>

//                   <td>
//                     <span
//                       style={{
//                         fontFamily: "var(--mono)",
//                         fontSize: 14,
//                         fontWeight: 600,
//                         color:
//                           l.result === "Pass"
//                             ? "var(--success)"
//                             : "var(--danger)",
//                       }}
//                     >
//                       {l.weight}g
//                     </span>
//                   </td>
//                   <td
//                     style={{ fontFamily: "var(--mono)", color: "var(--text3)" }}
//                   >
//                     {l.min_weight}–{l.max_weight}g
//                   </td>
//                   <td>
//                     <img
//                       src={getImageUrl(l.product_image)}
//                       alt="Part"
//                       style={{
//                         width: 50,
//                         height: 50,
//                         borderRadius: 6,
//                         objectFit: "cover",
//                       }}
//                     />
//                   </td>
//                   <td>
//                     <span
//                       className={`badge ${l.result === "Pass" ? "badge-success" : "badge-danger"}`}
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 4,
//                         width: "fit-content",
//                       }}
//                     >
//                       {l.result === "Pass" ? (
//                         <CheckCircle size={10} />
//                       ) : (
//                         <XCircle size={10} />
//                       )}{" "}
//                       {l.result}
//                     </span>
//                   </td>
//                   <td className="text2 mono">{l.serial_number || "—"}</td>
//                   <td className="text2">
//                     {new Date(l.recorded_at).toLocaleDateString()}
//                   </td>
//                   <td className="text3">
//                     {new Date(l.recorded_at)
//                       .toLocaleTimeString([], {
//                         hour: "2-digit",
//                         minute: "2-digit",
//                         hour12: true,
//                       })
//                       .replace(/\s*[APap][Mm]/g, "")}
//                   </td>
//                   {hasFailEntries && (
//                     <td>
//                       {l.result === "Fail" && (
//                         <button
//                           onClick={() => handleDelete(l.id)}
//                           disabled={deletingId === l.id}
//                           title="Delete this Fail entry"
//                           style={{
//                             background: "rgba(255,77,106,0.1)",
//                             border: "1px solid var(--danger)",
//                             borderRadius: 6,
//                             padding: "5px 8px",
//                             cursor:
//                               deletingId === l.id ? "not-allowed" : "pointer",
//                             color: "var(--danger)",
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 4,
//                             fontSize: 11,
//                             fontWeight: 600,
//                             opacity: deletingId === l.id ? 0.5 : 1,
//                           }}
//                         >
//                           <Trash2 size={12} />
//                           {deletingId === l.id ? "..." : "Delete"}
//                         </button>
//                       )}
//                     </td>
//                   )}
//                 </tr>
//               ))}
//               {entries.length === 0 && (
//                 <tr>
//                   <td
//                     colSpan={hasFailEntries ? 10 : 9}
//                     style={{
//                       textAlign: "center",
//                       color: "var(--text3)",
//                       padding: 20,
//                     }}
//                   >
//                     No entries found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         )}
//       </div>

//       <div
//         style={{
//           display: "flex",
//           justifyContent: "flex-end",
//           alignItems: "center",
//           gap: 12,
//           marginTop: 14,
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 6,
//             fontSize: 12,
//             color: "var(--text3)",
//           }}
//         >
//           <h6>Rows per page:</h6>
//           <select
//             value={pageSize}
//             onChange={handlePageSizeChange}
//             style={{
//               padding: "4px 8px",
//               borderRadius: 6,
//               background: "var(--surface2)",
//               border: "1px solid var(--border2)",
//               color: "var(--text)",
//               fontSize: 12,
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//             <option value={100}>100</option>
//           </select>
//         </div>

//         {total > 0 && (
//           <>
//             <span style={{ fontSize: 12, color: "var(--text3)" }}>
//               {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} of{" "}
//               {total}
//             </span>
//             <button
//               className="btn-secondary"
//               disabled={page === 1}
//               onClick={() => setPage((p) => Math.max(1, p - 1))}
//               style={{ opacity: page === 1 ? 0.5 : 1 }}
//             >
//               Prev
//             </button>
//             <button
//               className="btn-secondary"
//               disabled={page * pageSize >= total}
//               onClick={() => setPage((p) => p + 1)}
//               style={{ opacity: page * pageSize >= total ? 0.5 : 1 }}
//             >
//               Next
//             </button>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

import { useState, useEffect } from "react";
import {
  Plus,
  Scale,
  CheckCircle,
  XCircle,
  Search,
  Trash2,
  FileSpreadsheet,
} from "lucide-react";
import Modal from "../../components/ui/Modal";
import { productAPI, weightAPI } from "../../services/api";
import { exportWeightHistoryToExcel } from "../../utils/exportExcel";

const getImageUrl = (imagePath) => {
  if (!imagePath) return "https://via.placeholder.com/150";
  if (
    imagePath.startsWith("http://") ||
    imagePath.startsWith("https://") ||
    imagePath.startsWith("blob:")
  ) {
    return imagePath;
  }
  const apiUrl =
    process.env.REACT_APP_API_URL || "http://localhost:5000/backend";
  const serverOrigin = apiUrl.replace(/\/backend\/?$/, "");
  const cleanPath = imagePath.startsWith("/") ? imagePath : `/${imagePath}`;

  const finalPath = cleanPath.startsWith("/uploads/")
    ? `/backend${cleanPath}`
    : cleanPath;

  return `${serverOrigin}${finalPath}`;
};

export default function CompanyForms() {
  const [entries, setEntries] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [filter, setFilter] = useState("All");
  const [deletingId, setDeletingId] = useState(null);
  const [form, setForm] = useState({ product_id: "", weight: "" });
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // ── Date range + time range + product filter ────────────────
  // fromDate/toDate: "YYYY-MM-DD". fromTime/toTime: "HH:mm", optional —
  // left blank they default to 00:00 (start of day) / 23:59 (end of day).
  // productFilter: product id, "" = All products.
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [productFilter, setProductFilter] = useState("");
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
    }, 300);
    return () => clearTimeout(t);
  }, [search]);

  const hasDateFilter = !!(fromDate || toDate);

  // Builds { from, to } sent to the backend from the current date+time
  // filter. If only one of fromDate/toDate is picked, treats it as a
  // single-day range (old behaviour). Missing time = whole day (00:00–23:59).
  const buildRange = () => {
    if (!hasDateFilter) return {};
    const startDate = fromDate || toDate;
    const endDate = toDate || fromDate;
    return {
      from: `${startDate} ${fromTime || "00:00"}:00`,
      to: `${endDate} ${toTime || "23:59"}:59`,
    };
  };

  const load = () => {
    setLoading(true);
    Promise.all([
      weightAPI.list({
        limit: pageSize,
        offset: (page - 1) * pageSize,
        ...(filter !== "All" && { result: filter }),
        ...(debouncedSearch.trim() && { search: debouncedSearch.trim() }),
        ...(productFilter && { product_id: productFilter }),
        ...buildRange(),
      }),
      productAPI.list(),
    ])
      .then(([w, p]) => {
        setEntries(w.data.entries);
        setTotal(w.data.total || 0);
        setProducts(p.data);
      })
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    load();
  }, [
    page,
    pageSize,
    filter,
    debouncedSearch,
    productFilter,
    fromDate,
    toDate,
    fromTime,
    toTime,
  ]);

  const handleFromDateChange = (e) => {
    const v = e.target.value;
    setFromDate(v);
    if (toDate && v && v > toDate) setToDate(v); // keep range valid
    setPage(1);
  };
  const handleToDateChange = (e) => {
    const v = e.target.value;
    setToDate(v);
    if (fromDate && v && v < fromDate) setFromDate(v); // keep range valid
    setPage(1);
  };
  const handleFromTimeChange = (e) => {
    setFromTime(e.target.value);
    setPage(1);
  };
  const handleToTimeChange = (e) => {
    setToTime(e.target.value);
    setPage(1);
  };
  const handleProductFilterChange = (e) => {
    setProductFilter(e.target.value);
    setPage(1);
  };
  const clearDateFilters = () => {
    setFromDate("");
    setToDate("");
    setFromTime("");
    setToTime("");
    setPage(1);
  };

  const handlePageSizeChange = (e) => {
    setPageSize(Number(e.target.value));
    setPage(1);
  };

  // Human-readable summary of the active range, e.g.
  // "05 Sep 00:00 → 07 Sep 23:59" — shown next to the export button so the
  // user can see exactly what will be exported before clicking.
  const rangeLabel = (() => {
    if (!hasDateFilter) return "";
    const range = buildRange();
    const fmt = (iso) => {
      const [d, t] = iso.split(" ");
      const dt = new Date(`${d}T00:00:00`);
      const day = dt.toLocaleDateString(undefined, {
        day: "2-digit",
        month: "short",
      });
      return `${day} ${t.slice(0, 5)}`;
    };
    return `${fmt(range.from)} → ${fmt(range.to)}`;
  })();

  const selected = products.find((p) => p.id === form.product_id);
  const liveResult =
    selected && form.weight
      ? +form.weight >= selected.min_weight &&
        +form.weight <= selected.max_weight
        ? "Pass"
        : "Fail"
      : null;

  const submit = async () => {
    if (!form.product_id || !form.weight) return;
    setSaving(true);
    try {
      await weightAPI.create({
        product_id: form.product_id,
        weight: +form.weight,
      });
      setForm({ product_id: "", weight: "" });
      setModal(false);
      load();
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Do you want to permanently delete this failed entry?"))
      return;
    setDeletingId(id);
    try {
      await weightAPI.delete(id);
      load();
    } catch (e) {
      alert(e.message || "Delete failed");
    } finally {
      setDeletingId(null);
    }
  };

  const handleExport = async () => {
    if (!hasDateFilter) return;
    setExporting(true);
    try {
      const range = buildRange();
      // limit: 10000 — pulls the FULL matching range, not just current page.
      // Backend's getAll uses findAndCountAll; `limit` only caps `rows`
      // returned here (not `total`), so this is safe even on a busy range.
      // Same filters as the table (product/result/search) so what's on
      // screen is exactly what gets exported.
      const res = await weightAPI.list({
        ...range,
        ...(productFilter && { product_id: productFilter }),
        ...(filter !== "All" && { result: filter }),
        ...(debouncedSearch.trim() && { search: debouncedSearch.trim() }),
        limit: 10000,
      });
      const rangeEntries = res.data.entries || [];
      if (rangeEntries.length === 0) {
        alert("No entries found for the selected filters");
        return;
      }
      const selectedProductName = productFilter
        ? products.find((p) => String(p.id) === String(productFilter))?.name
        : null;
      await exportWeightHistoryToExcel(rangeEntries, {
        from: range.from,
        to: range.to,
        productName: selectedProductName,
        result: filter !== "All" ? filter : null,
      });
    } catch (e) {
      alert(e.message || "Export failed");
    } finally {
      setExporting(false);
    }
  };

  // Backend नेच filter (result=Pass/Fail) apply करून, योग्य pagination सहित
  // entries पाठवलेल्या असतात — इथे परत client-side filter करायची गरज नाही.
  // Actions column फक्त तेव्हाच दाखवायचा जेव्हा current page वर किमान एक Fail entry असेल
  const hasFailEntries = entries.some((e) => e.result === "Fail");

  return (
    <div style={{ padding: 28 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: 24,
        }}
      >
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 700 }}>Weight History</h1>
          <p style={{ color: "var(--text2)", fontSize: 13, marginTop: 2 }}>
            Record and review weight check entries
          </p>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 12,
          marginBottom: 18,
        }}
      >
        <div style={{ display: "flex", gap: 8 }}>
          {["All", "Pass", "Fail"].map((f) => (
            <button
              key={f}
              onClick={() => {
                setFilter(f);
                setPage(1);
              }}
              style={{
                padding: "6px 16px",
                borderRadius: 20,
                fontSize: 12,
                fontWeight: 600,
                background: filter === f ? "var(--accent)" : "var(--surface2)",
                color: filter === f ? "#0D0F14" : "var(--text2)",
                border:
                  "1px solid " +
                  (filter === f ? "var(--accent)" : "var(--border2)"),
              }}
            >
              {f}
            </button>
          ))}
        </div>

        <div style={{ position: "relative", flex: "1 1 260px", maxWidth: 340 }}>
          <Search
            size={14}
            color="var(--text3)"
            style={{
              position: "absolute",
              left: 10,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search by Part ID, Name, Serial No..."
            style={{
              width: "100%",
              padding: "8px 12px 8px 32px",
              borderRadius: 20,
              background: "var(--surface2)",
              border: "1px solid var(--border2)",
              color: "var(--text)",
              fontSize: 12.5,
              outline: "none",
            }}
          />
        </div>
      </div>

      {/* Product + date-range + time-range filter — drives both the table
          below and the Excel export, so what's on screen is what's exported. */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          flexWrap: "wrap",
          gap: 12,
          marginBottom: 18,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <label style={{ fontSize: 11, color: "var(--text3)" }}>Part</label>
          <select
            value={productFilter}
            onChange={handleProductFilterChange}
            style={{
              padding: "7px 10px",
              borderRadius: 8,
              background: "var(--surface2)",
              border: "1px solid var(--border2)",
              color: "var(--text)",
              fontSize: 12.5,
              minWidth: 150,
            }}
          >
            <option value="">All Parts</option>
            {products.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name} ({p.code})
              </option>
            ))}
          </select>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <label style={{ fontSize: 11, color: "var(--text3)" }}>
            From date
          </label>
          <input
            type="date"
            value={fromDate}
            onChange={handleFromDateChange}
            style={{
              padding: "7px 10px",
              borderRadius: 8,
              background: "var(--surface2)",
              border: "1px solid var(--border2)",
              color: "var(--text)",
              fontSize: 12.5,
            }}
          />
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <label style={{ fontSize: 11, color: "var(--text3)" }}>
            From time
          </label>
          <input
            type="time"
            value={fromTime}
            onChange={handleFromTimeChange}
            disabled={!hasDateFilter}
            title="Defaults to 00:00 if left blank"
            style={{
              padding: "7px 10px",
              borderRadius: 8,
              background: "var(--surface2)",
              border: "1px solid var(--border2)",
              color: "var(--text)",
              fontSize: 12.5,
              opacity: hasDateFilter ? 1 : 0.5,
            }}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <label style={{ fontSize: 11, color: "var(--text3)" }}>To date</label>
          <input
            type="date"
            value={toDate}
            onChange={handleToDateChange}
            style={{
              padding: "7px 10px",
              borderRadius: 8,
              background: "var(--surface2)",
              border: "1px solid var(--border2)",
              color: "var(--text)",
              fontSize: 12.5,
            }}
          />
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <label style={{ fontSize: 11, color: "var(--text3)" }}>To time</label>
          <input
            type="time"
            value={toTime}
            onChange={handleToTimeChange}
            disabled={!hasDateFilter}
            title="Defaults to 23:59 if left blank"
            style={{
              padding: "7px 10px",
              borderRadius: 8,
              background: "var(--surface2)",
              border: "1px solid var(--border2)",
              color: "var(--text)",
              fontSize: 12.5,
              opacity: hasDateFilter ? 1 : 0.5,
            }}
          />
        </div>

        {hasDateFilter && (
          <button
            onClick={clearDateFilters}
            title="Clear date/time filter"
            style={{
              padding: "7px 10px",
              borderRadius: 8,
              background: "var(--surface2)",
              border: "1px solid var(--border2)",
              color: "var(--text2)",
              fontSize: 12,
              cursor: "pointer",
            }}
          >
            Clear
          </button>
        )}

        <button
          onClick={handleExport}
          disabled={!hasDateFilter || exporting}
          title={
            !hasDateFilter
              ? "Select a from-date first"
              : "Export the currently filtered entries to Excel"
          }
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            padding: "7px 14px",
            borderRadius: 8,
            background: !hasDateFilter ? "var(--surface2)" : "var(--accent)",
            border:
              "1px solid " +
              (!hasDateFilter ? "var(--border2)" : "var(--accent)"),
            color: !hasDateFilter ? "var(--text3)" : "#0D0F14",
            fontSize: 12.5,
            fontWeight: 600,
            cursor: !hasDateFilter || exporting ? "not-allowed" : "pointer",
            opacity: exporting ? 0.6 : 1,
          }}
        >
          <FileSpreadsheet size={14} />
          {exporting ? "Exporting..." : "Export Excel"}
        </button>

        {hasDateFilter && !loading && (
          <span
            style={{ fontSize: 11, color: "var(--text3)", paddingBottom: 8 }}
          >
            {total} {total === 1 ? "entry" : "entries"} · {rangeLabel}
            {productFilter &&
              ` · ${products.find((p) => String(p.id) === String(productFilter))?.name || ""}`}
          </span>
        )}
      </div>

      <div className="card" style={{ padding: 0, overflow: "hidden" }}>
        {loading ? (
          <div
            style={{ padding: 24, textAlign: "center", color: "var(--text2)" }}
          >
            Loading...
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Part ID</th>
                <th>Part</th>
                <th>Weight</th>
                <th>Range</th>
                <th>Image</th>
                <th>Result</th>
                <th>Serial Number</th>
                <th>Date</th>
                <th>Time</th>
                {hasFailEntries && <th>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {entries.map((l) => (
                <tr key={l.id}>
                  <td>
                    <div
                      style={{
                        fontSize: 11,
                        color: "var(--text3)",
                        fontFamily: "var(--mono)",
                        marginLeft: 14,
                      }}
                    >
                      {l.product_code}
                    </div>
                  </td>

                  <td>
                    <div style={{ fontWeight: 500 }}>{l.product_name}</div>
                  </td>

                  <td>
                    <span
                      style={{
                        fontFamily: "var(--mono)",
                        fontSize: 14,
                        fontWeight: 600,
                        color:
                          l.result === "Pass"
                            ? "var(--success)"
                            : "var(--danger)",
                      }}
                    >
                      {l.weight}g
                    </span>
                  </td>
                  <td
                    style={{ fontFamily: "var(--mono)", color: "var(--text3)" }}
                  >
                    {l.min_weight}–{l.max_weight}g
                  </td>
                  <td>
                    <img
                      src={getImageUrl(l.product_image)}
                      alt="Part"
                      style={{
                        width: 50,
                        height: 50,
                        borderRadius: 6,
                        objectFit: "cover",
                      }}
                    />
                  </td>
                  <td>
                    <span
                      className={`badge ${l.result === "Pass" ? "badge-success" : "badge-danger"}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                        width: "fit-content",
                      }}
                    >
                      {l.result === "Pass" ? (
                        <CheckCircle size={10} />
                      ) : (
                        <XCircle size={10} />
                      )}{" "}
                      {l.result}
                    </span>
                  </td>
                  <td className="text2 mono">{l.serial_number || "—"}</td>
                  <td className="text2">
                    {new Date(l.recorded_at).toLocaleDateString()}
                  </td>
                  <td className="text3">
                    {new Date(l.recorded_at)
                      .toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })
                      .replace(/\s*[APap][Mm]/g, "")}
                  </td>
                  {hasFailEntries && (
                    <td>
                      {l.result === "Fail" && (
                        <button
                          onClick={() => handleDelete(l.id)}
                          disabled={deletingId === l.id}
                          title="Delete this Fail entry"
                          style={{
                            background: "rgba(255,77,106,0.1)",
                            border: "1px solid var(--danger)",
                            borderRadius: 6,
                            padding: "5px 8px",
                            cursor:
                              deletingId === l.id ? "not-allowed" : "pointer",
                            color: "var(--danger)",
                            display: "flex",
                            alignItems: "center",
                            gap: 4,
                            fontSize: 11,
                            fontWeight: 600,
                            opacity: deletingId === l.id ? 0.5 : 1,
                          }}
                        >
                          <Trash2 size={12} />
                          {deletingId === l.id ? "..." : "Delete"}
                        </button>
                      )}
                    </td>
                  )}
                </tr>
              ))}
              {entries.length === 0 && (
                <tr>
                  <td
                    colSpan={hasFailEntries ? 10 : 9}
                    style={{
                      textAlign: "center",
                      color: "var(--text3)",
                      padding: 20,
                    }}
                  >
                    No entries found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 12,
          marginTop: 14,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontSize: 12,
            color: "var(--text3)",
          }}
        >
          <h6>Rows per page:</h6>
          <select
            value={pageSize}
            onChange={handlePageSizeChange}
            style={{
              padding: "4px 8px",
              borderRadius: 6,
              background: "var(--surface2)",
              border: "1px solid var(--border2)",
              color: "var(--text)",
              fontSize: 12,
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>

        {total > 0 && (
          <>
            <span style={{ fontSize: 12, color: "var(--text3)" }}>
              {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} of{" "}
              {total}
            </span>
            <button
              className="btn-secondary"
              disabled={page === 1}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              style={{ opacity: page === 1 ? 0.5 : 1 }}
            >
              Prev
            </button>
            <button
              className="btn-secondary"
              disabled={page * pageSize >= total}
              onClick={() => setPage((p) => p + 1)}
              style={{ opacity: page * pageSize >= total ? 0.5 : 1 }}
            >
              Next
            </button>
          </>
        )}
      </div>
    </div>
  );
}
